import * as z from "zod";

/**
 * Canonical product ids for merchant unified onboarding. Only some have a
 * registered ProductOnboardingDef; the rest show as coming soon in the picker.
 */
export const UNIFIED_ONBOARDING_PRODUCT_IDS = [
  "returns",
  "chargebacks",
  "recover",
  "email",
  "sms",
  "commerce_agent",
  // Payments cloud. "chargeback_deflections" rather than "resolve" so the id
  // is not bound to whatever the product is currently branded.
  "chargeback_recovery",
  "chargeback_alerts",
  "chargeback_deflections",
  "oms",
] as const;

export type UnifiedOnboardingProductId =
  (typeof UNIFIED_ONBOARDING_PRODUCT_IDS)[number];

export const UnifiedOnboardingProductIdSchema = z.enum(
  UNIFIED_ONBOARDING_PRODUCT_IDS,
);

export function isUnifiedOnboardingProductId(
  value: string,
): value is UnifiedOnboardingProductId {
  return UnifiedOnboardingProductIdSchema.safeParse(value).success;
}

export function parseUnifiedOnboardingProductId(
  value: string | null | undefined,
): UnifiedOnboardingProductId | undefined {
  if (value == null) {
    return undefined;
  }
  const parsed = UnifiedOnboardingProductIdSchema.safeParse(value);
  return parsed.success ? parsed.data : undefined;
}
